var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.419,
    height: 100,
    viewBox: "0 0 180.419 139.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-13.652 -16.343)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M42.176,81.519S56.57,68.944,71.251,68.944c0,0,35.887,1.631,47.306-17.944,0,0,16.312,11.419,16.312,30.993Z",
    transform: "translate(17.498 21.877)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(76.575 16.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M105.076,65.066H56.519a.083.083,0,0,1-.083-.083V45.39c0-12.724,9.417-23.888,22.085-25.046a24.391,24.391,0,0,1,26.535,22.04c.067.737.1,1.478.1,2.218v2.923a1.957,1.957,0,0,0,1.949,1.949h0a1.957,1.957,0,0,0,1.949-1.949V45.5c0-15.241-11.686-28.414-26.915-29.126a28.293,28.293,0,0,0-29.574,26.95c-.02.426-.029.853-.031,1.279V68.882a.083.083,0,0,0,.083.083h56.358a.083.083,0,0,0,.083-.083h0V57.271a1.958,1.958,0,0,0-1.953-1.941h0a1.959,1.959,0,0,0-1.949,1.949v7.712A.08.08,0,0,1,105.076,65.066Z",
    transform: "translate(-52.537 -16.343)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(58.061 64.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M45.086,75.606A32.318,32.318,0,0,1,49.8,58.787a1.9,1.9,0,0,0-.581-2.61L49.1,56.1a1.872,1.872,0,0,0-2.584.577h0a36.194,36.194,0,0,0-5.329,18.924v2.61A1.88,1.88,0,0,0,43.066,80.1H43.2a1.879,1.879,0,0,0,1.882-1.879v0Z",
    transform: "translate(-41.187 -39.178)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M94.085,49.514a34.351,34.351,0,0,1,34.352,34.349V84.6a1.935,1.935,0,0,0,1.935,1.935h.028a1.934,1.934,0,0,0,1.936-1.933v-.744A38.251,38.251,0,0,0,94.085,45.615H73.264a36.242,36.242,0,0,0-24.547,9.577,1.957,1.957,0,0,0,.268,3.1h0a1.932,1.932,0,0,0,2.341-.241,32.415,32.415,0,0,1,21.938-8.536Z",
    transform: "translate(-36.837 -45.615)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    d: "M6.12-1.25H171.8a7.379,7.379,0,0,1,7.37,7.37v39a7.379,7.379,0,0,1-7.37,7.37H6.12a7.379,7.379,0,0,1-7.37-7.37v-39A7.379,7.379,0,0,1,6.12-1.25ZM171.8,49.423a4.312,4.312,0,0,0,4.307-4.307v-39A4.312,4.312,0,0,0,171.8,1.813H6.12A4.312,4.312,0,0,0,1.813,6.12v39A4.312,4.312,0,0,0,6.12,49.423Z",
    transform: "translate(14.902 103.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M31,88.065a15.884,15.884,0,0,1,14.681-1.631l-1.4,4.993-6.854,2.649-6.047-3.7Z",
    transform: "translate(10.443 43.536)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M48,88.065a15.884,15.884,0,0,1,14.681-1.631l-1.4,4.993-6.854,2.649-6.047-3.7Z",
    transform: "translate(21.174 43.536)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M65,88.065a15.884,15.884,0,0,1,14.681-1.631l-1.4,4.993-6.854,2.649-6.047-3.7Z",
    transform: "translate(31.905 43.536)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M81,88.065a15.884,15.884,0,0,1,14.681-1.631l-1.4,4.993-6.854,2.649-6.047-3.7Z",
    transform: "translate(42.005 43.536)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M98,88.065a15.884,15.884,0,0,1,14.681-1.631l-1.4,4.993-6.854,2.649-6.047-3.7Z",
    transform: "translate(52.736 43.536)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    d: "M9.97-1A10.97,10.97,0,1,1-1,9.97,10.983,10.983,0,0,1,9.97-1Zm0,19.49a8.52,8.52,0,1,0-8.52-8.52A8.529,8.529,0,0,0,9.97,18.49Z",
    transform: "translate(94.866 75.562)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M65.35,74.194l-1.664-1.8a16.27,16.27,0,0,0,2.42-2.978c1.261-2.037,1.536-3.726.817-5.02l2.143-1.19C71.806,68.143,65.614,73.949,65.35,74.194Z",
    transform: "translate(31.351 29.779)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M76.138,74.193c-.265-.245-6.455-6.05-3.716-10.987L74.565,64.4c-.718,1.294-.443,2.983.818,5.02A16.274,16.274,0,0,0,77.8,72.394Z",
    transform: "translate(36.556 29.779)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    d: "M8.382-1A9.382,9.382,0,1,1-1,8.382,9.392,9.392,0,0,1,8.382-1Zm0,16.312A6.931,6.931,0,1,0,1.451,8.382,6.939,6.939,0,0,0,8.382,15.312Z",
    transform: "translate(40.295 121.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    d: "M8.382-1A9.382,9.382,0,1,1-1,8.382,9.392,9.392,0,0,1,8.382-1Zm0,16.312A6.931,6.931,0,1,0,1.451,8.382,6.939,6.939,0,0,0,8.382,15.312Z",
    transform: "translate(67.581 121.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    d: "M8.382-1A9.382,9.382,0,1,1-1,8.382,9.392,9.392,0,0,1,8.382-1Zm0,16.312A6.931,6.931,0,1,0,1.451,8.382,6.939,6.939,0,0,0,8.382,15.312Z",
    transform: "translate(94.866 121.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    d: "M8.382-1A9.382,9.382,0,1,1-1,8.382,9.392,9.392,0,0,1,8.382-1Zm0,16.312A6.931,6.931,0,1,0,1.451,8.382,6.939,6.939,0,0,0,8.382,15.312Z",
    transform: "translate(122.152 121.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    d: "M8.382-1A9.382,9.382,0,1,1-1,8.382,9.392,9.392,0,0,1,8.382-1Zm0,16.312A6.931,6.931,0,1,0,1.451,8.382,6.939,6.939,0,0,0,8.382,15.312Z",
    transform: "translate(149.436 121.114)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    d: "M17.155,3.676A13.479,13.479,0,0,0,3.676,17.155V37.985H30.633V17.155A13.479,13.479,0,0,0,17.155,3.676m0-3.676A17.155,17.155,0,0,1,34.309,17.155V41.661H0V17.155A17.155,17.155,0,0,1,17.155,0Z",
    transform: "translate(87.479 26.126)",
    fill: "#36c96d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot_password.326af78db4470ad87eb78711c41e3c01.svg";
export { ForwardRef as ReactComponent };